const MEDIA_TYPES = {
  image: 'image',
  video: 'video',
  document: 'document',
};

export default MEDIA_TYPES;
